const LetterGenerator = ((length) => {
    const arr = [];
    let letterCode = 65; // char for A letter
    const charLength = letterCode + length;

    for (; letterCode < charLength; letterCode += 1) {
        arr.push(String.fromCharCode(letterCode));
    }

    return arr;
});

export default LetterGenerator;
